module.exports = __webpack_public_path__ + "img/home-logo.6a128875.png";